import { z } from "zod";
import type { MikroPurchaseSuggestionResult } from "./mikro-suggestion-model";

const amount = z.number().finite();
const suggestion = z.object({
  id: z.string(), materialCode: z.string(), materialName: z.string(),
  warehouseCode: z.string(), warehouseName: z.string(), unit: z.string(),
  onHandQuantity: amount, inboundQuantity: amount, minimumStockQuantity: amount,
  leadTimeDays: amount, totalRequiredQuantity: amount, workOrderCount: amount,
  overdueRequiredQuantity: amount, overdueWorkOrderCount: amount,
  firstRequiredAt: z.string().nullable(), lastRequiredAt: z.string().nullable(),
  projectedStockQuantity: amount, productionNeedQuantity: amount, minimumStockNeedQuantity: amount,
  events: z.array(z.object({
    id: z.string(), type: z.enum(["DEMAND", "INBOUND"]), eventAt: z.string().nullable(),
    referenceNo: z.string(), referenceCount: amount, label: z.string(), quantity: amount,
  })),
});
const result = z.object({
  items: z.array(suggestion), source: z.literal("MICRO_ERP"),
  refreshedAt: z.string(), truncated: z.boolean(),
});
export function parseSuggestionResult(value: unknown): MikroPurchaseSuggestionResult {
  const parsed = result.safeParse(value);
  if (!parsed.success) throw new Error("Mikro ihtiyaç önerisi yanıtı geçersiz.");
  return parsed.data;
}
